import ExamTimeUp from './ExamTimeUp';

export default ExamTimeUp;
